
export class GetCodeTO {

    email: string;

    constructor (email: string){
        this.email = email;
    }
}